import { render, staticRenderFns } from "./audioPlay.vue?vue&type=template&id=237a5ff8&scoped=true&"
import script from "./audioPlay.vue?vue&type=script&lang=js&"
export * from "./audioPlay.vue?vue&type=script&lang=js&"
import style0 from "./audioPlay.vue?vue&type=style&index=0&id=237a5ff8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237a5ff8",
  null
  
)

export default component.exports